export default __webpack_public_path__ + "static/media/ssl.095ce5fb.png";